<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <BitQLoginPage :service_title="service_title" :showcase_id="showcase_id"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import BitQLoginPage from '@/components/bitq/BitQLoginPage'

export default {
  name: 'BitQParchi',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Parchi Tematici", link : 'conv-bitq-parchi' } ],

        // Nome welfarebit del servizio
        service_title : "Parchi Tematici",

        // Identificativo della vetrina ( fornito da BitQ )
        showcase_id : 151
    }
  },
  components: {
    PageTagline,
    BitQLoginPage
  }
}
</script>

<style scoped></style>